import { render, staticRenderFns } from "./InfomationPosturePage.vue?vue&type=template&id=2a62dc9b&scoped=true&"
import script from "./InfomationPosturePage.vue?vue&type=script&lang=js&"
export * from "./InfomationPosturePage.vue?vue&type=script&lang=js&"
import style0 from "./InfomationPosturePage.vue?vue&type=style&index=0&id=2a62dc9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a62dc9b",
  null
  
)

export default component.exports